module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BoldItalic-WebM-018425623b02fd91f99307c1877591c8.woff2";